import {
  createBrowserRouter,
} from "react-router-dom";
import Login from "./Components/Login";
import ProtectedRoute from "./Components/Shared/ProtectedRoute/ProtectedRoute";
import RouteErrorFallback from "./Components/Shared/RouteErrorFallback/RouteErrorFallback";
import Home from "./Components/Home";
import ForgotPassword from "./Components/ForgotPassword/ForgotPassword";
import Register from "./Components/Register/Register";
import ResetPassword from "./Components/ResetPassword/ResetPassword";
import Billing from "./Components/Billing";
import Agents from "./Components/Agents";
import KnowledgeDatabase from "./Components/KnowledgeDatabase/KnowledgeDatabasePage";
import KnowledgeDatabaseEntries from "./Components/KnowledgeDatabase/KnowledgeDatabaseDetail/KnowledgeDatabaseDetail";
import UserProfile from "./Components/Profile/Profile";
import MessageDisplay from "./Components/Messages";
import ChangePassword from "./Components/Profile/ChangePassword/ChangePassword";
import UserList from "./Components/Users/Users";
import Transactions from "./Components/Transactions";
import Credentials from "./Components/Credentials";
import EmailVerificationPage from "./Components/EmailVerification/EmailVerification";
import PaymentStatus from "./Components/PaymentStatus/PaymentStatus";
import Settings from "./Components/Settings/Settings";
import Escalations from "./Components/Escalations/Escalations";
import AcceptTerms from "./Components/AcceptTerms/AcceptTerms";
import NotFound from "./Components/NotFound/NotFound";

import { basename } from "./Constants/env"

// Wrapper to provide error handling within protected route layout
const ProtectedRouteWithError = ({ component, ...rest }) => (
  <ProtectedRoute component={component} {...rest} />
);

const Router = createBrowserRouter([
  {
    path: "/escalations",
    element: <ProtectedRoute component={Escalations} exact />,
    errorElement: <ProtectedRouteWithError component={RouteErrorFallback} />,
  },
  {
    path: "/",
    element: <ProtectedRoute component={Home} exact />,
    errorElement: <ProtectedRouteWithError component={RouteErrorFallback} />,
  },
  {
    path: "/users",
    element: <ProtectedRoute component={UserList} exact />,
    errorElement: <ProtectedRouteWithError component={RouteErrorFallback} />,
  },
  {
    path: "/billing",
    element: <ProtectedRoute component={Billing} exact />,
    errorElement: <ProtectedRouteWithError component={RouteErrorFallback} />,
  },
  {
    path: "/transactions",
    element: <ProtectedRoute component={Transactions} exact />,
    errorElement: <ProtectedRouteWithError component={RouteErrorFallback} />,
  },
  {
    path: "/credentials",
    element: <ProtectedRoute component={Credentials} exact />,
    errorElement: <ProtectedRouteWithError component={RouteErrorFallback} />,
  },
  {
    path: "/agents",
    element: <ProtectedRoute component={Agents} exact />,
    errorElement: <ProtectedRouteWithError component={RouteErrorFallback} />,
  },
  {
    path: "/messages",
    element: <ProtectedRoute component={MessageDisplay} exact />,
    errorElement: <ProtectedRouteWithError component={RouteErrorFallback} />,
  },
  {
    path: "/knowledge-base",
    element: <ProtectedRoute component={KnowledgeDatabase} exact />,
    errorElement: <ProtectedRouteWithError component={RouteErrorFallback} />,
  },
  {
    path: "/knowledge-base/:id",
    element: <ProtectedRoute component={KnowledgeDatabaseEntries} exact />,
    errorElement: <ProtectedRouteWithError component={RouteErrorFallback} />,
  },
  {
    path: "/profile",
    element: <ProtectedRoute component={UserProfile} exact />,
    errorElement: <ProtectedRouteWithError component={RouteErrorFallback} />,
  },
  {
    path: "/change-password",
    element: <ProtectedRoute component={ChangePassword} exact />,
    errorElement: <ProtectedRouteWithError component={RouteErrorFallback} />,
  },
  {
    path: "/settings",
    element: <ProtectedRoute component={Settings} exact />,
    errorElement: <ProtectedRouteWithError component={RouteErrorFallback} />,
  },
  {
    path: "/payments",
    element: <ProtectedRoute component={PaymentStatus} useLayout={false} />,
    errorElement: <ProtectedRouteWithError component={RouteErrorFallback} />,
  },
  {
    path: "/accept-terms",
    Component: AcceptTerms,
  },
  {
    path: "/404",
    Component: NotFound,
  },
  {
    path: "login",
    Component: Login,
  },
  {
    path: "register",
    Component: Register,
  },
  {
    path: "forgot-password",
    Component: ForgotPassword,
  },
  {
    path: "reset-password/:token",
    Component: ResetPassword,
  },
  {
    path: "verify-email/:token",
    Component: EmailVerificationPage,
  },
  {
    path: "*",
    Component: NotFound,
  },
],
  { basename }
);

export default Router;
